/* eslint-disable */
import React, { Component, type JSX } from 'react';
import { SearchBijlesItem } from './SearchBijlesItem';
import { SearchBijlesResponse, SearchBijlesResult } from './SearchBijles.model';

type Filters = SearchBijlesResponse['filters'];
type Results = SearchBijlesResult[];

interface ComponentProps {
  filters: Filters;
  results: Results;
  product: string;
  list_type: string;
}

enum DisplayMode {
    List = 'list',
    Grid = 'grid',
}

interface ComponentState {
    displayMode: DisplayMode;
    showAllResults: boolean;
}

export class SearchBijlesResults extends Component<ComponentProps, ComponentState> {
    /**
     * Change de display of the results
     * Options: list, grid
     */
    constructor(props: ComponentProps) {
        super(props);
        this.state = {
            displayMode: DisplayMode.Grid,
            showAllResults: props.list_type !== 'short',
        };
    }

    /**
    * Sort results by distance, with hub priority within 1km radius
    */
    private sortByDistanceWithHubPriority(results: Results): SearchBijlesResult[] {
        return [...results].sort((a, b) => {
          const distanceA = parseFloat(a.Distance || '0');
          const distanceB = parseFloat(b.Distance || '0');

          // If distances are within 1km of each other
          if (Math.abs(distanceA - distanceB) <= 1) {
            const isHubA = a.timberpost?.is_hub === '1';
            const isHubB = b.timberpost?.is_hub === '1';

            // If one is a hub and the other isn't, hub gets priority
            if (isHubA && !isHubB) return -1;
            if (!isHubA && isHubB) return 1;
          }

          // Otherwise, sort by distance
          return distanceA - distanceB;
        });
    }

    /**
     * Function to load all results
     */
    private loadMoreResults = () => {
        this.setState({
            showAllResults: true,
        });
    };

    /**
     * Function to hide extra results
     */
    private showLessResults = () => {
        this.setState({
            showAllResults: false,
        });
    };


    /**
     * Sort the items and render the list.
     */
    public render(): JSX.Element {
        let { results, product, list_type } = this.props;
        const { displayMode, showAllResults } = this.state;

        let search = window.location.search;
        let params = new URLSearchParams(search);

        if (params.toString().length === 0) {
          results = this.sortByDistanceWithHubPriority(results);
        }

        const visibleResults = showAllResults ? results : results.slice(0, 6);

        const list = visibleResults.map((result: SearchBijlesResult, key: number) => (
            <SearchBijlesItem
                key={key}
                product={product}
                props={result} />
        ));

        return (
          <div id="search-results">
            <div className="row">
              <div className="display_options">
                <button
                    onClick={() => this.setState({ displayMode: DisplayMode.List })}
                    className={`display_list ${displayMode === DisplayMode.List ? 'display_active' : ''}`}
                    title="Weergave wijzigen in lijst"
                    disabled={displayMode === DisplayMode.List}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <g id="Frame">
                      <path id="Vector" d="M6.66602 5H17.4993" stroke="currentColor" strokeWidth="2.08333" strokeLinecap="round" strokeLinejoin="round" fill="currentColor"/>
                      <path id="Vector_2" d="M6.66602 10H17.4993" stroke="currentColor" strokeWidth="2.08333" strokeLinecap="round" strokeLinejoin="round" fill="currentColor"/>
                      <path id="Vector_3" d="M6.66602 15H17.4993" stroke="currentColor" strokeWidth="2.08333" strokeLinecap="round" strokeLinejoin="round" fill="currentColor"/>
                      <path id="Vector_4" d="M2.5 5H2.50833" stroke="currentColor" strokeWidth="2.08333" strokeLinecap="round" strokeLinejoin="round" fill="currentColor"/>
                      <path id="Vector_5" d="M2.5 10H2.50833" stroke="currentColor" strokeWidth="2.08333" strokeLinecap="round" strokeLinejoin="round" fill="currentColor"/>
                      <path id="Vector_6" d="M2.5 15H2.50833" stroke="currentColor" strokeWidth="2.08333" strokeLinecap="round" strokeLinejoin="round" fill="currentColor"/>
                    </g>
                  </svg>
                </button>
                <button
                    onClick={() => this.setState({ displayMode: DisplayMode.Grid })}
                    className={`display_grid ${displayMode === DisplayMode.Grid ? 'display_active' : ''}`}
                    title="Weergave wijzigen in grid"
                    disabled={displayMode === DisplayMode.Grid}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <g id="Frame">
                      <path id="Vector" d="M8 16H3V20C3 20.621 3.52 21 4 21H8V16ZM14.6 21V16H9.4V21H14.6ZM21 16H16V21H20C20.478 21 21 20.621 21 20V16ZM21 14.6V9.4H16V14.6H21ZM3 9.4V14.6H8V9.4H3ZM14.6 9.4H9.4V14.6H14.6V9.4ZM16 3V8H21V4C21 3.522 20.621 3 20 3H16ZM8 8V3H4C3.38 3 3 3.519 3 4V8H8ZM14.6 3H9.4V8H14.6V3Z" fill="currentColor"/>
                    </g>
                  </svg>
                </button>
              </div>
              <div className="container component-4 right yellow">
              </div>
              <span className="clear"></span>
              <ul className={`list-item-container col-md-12 ${displayMode}`}>
                {list}
              </ul>
                {!showAllResults && results.length > 6 && list_type === 'short' && (
                    <button onClick={this.loadMoreResults} className="load-more-button">
                        Toon alle {results.length} vestigingen <i className="fa-solid fa-circle-chevron-down"></i>
                    </button>
                )}

                {showAllResults && list_type === 'short' && (
                    <button onClick={this.showLessResults} className="load-more-button">
                        Toon minder vestigingen <i className="fa-solid fa-circle-chevron-up"></i>
                    </button>
                )}
            </div>
          </div>
        );
    }
}
